import React from 'react';
import Modal from "../component/modal";  // 假设你的 Modal 组件在这个路径下

class TagModal extends React.Component {
    render() {
        const { tagOptions, tempSelectedTags, handleTagToggle, closeTagOptions, confirmTagSelection } = this.props;

        return (
            <Modal origin='xkCoachBottom' onCancel={closeTagOptions}>
                <div className='show-region-modal'>
                    <div className="modal-title">
                        选择院校标签
                        <svg t="1676039031388" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10861" width="16" height="16" onClick={closeTagOptions}>
                            <path
                                d="M511.232 438.8352L112.9984 40.6016A51.2 51.2 0 0 0 40.6016 112.9984L438.784 511.232 40.6016 909.4656a51.2 51.2 0 1 0 72.3968 72.448l398.2336-398.2848 398.2336 398.2848a51.2 51.2 0 1 0 72.448-72.448l-398.2848-398.2336 398.2848-398.2336A51.2 51.2 0 0 0 909.4656 40.601">
                            </path>
                        </svg>
                    </div>
                    <div className="modal-center">
                        <div className="options-container">
                            {tagOptions.map(option => (
                                <label key={option.id}>
                                    <input 
                                        type="checkbox" 
                                        checked={tempSelectedTags.includes(option.id)} 
                                        onChange={() => handleTagToggle(option.id)} 
                                    />
                                    {option.name}
                                </label>
                            ))}
                        </div>
                    </div>
                    <div className="modal-bottom">
                        <div className="btn cancel" onClick={closeTagOptions}>关闭</div>
                        <div className="btn confirm" onClick={confirmTagSelection}>确定</div>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default TagModal;



// WEBPACK FOOTER //
// ./src/pages/SelectSubject/TagModal.js